import { render, staticRenderFns } from "./CadastroProduto.vue?vue&type=template&id=35984911&scoped=true"
import script from "./CadastroProduto.vue?vue&type=script&lang=js"
export * from "./CadastroProduto.vue?vue&type=script&lang=js"
import style0 from "./CadastroProduto.vue?vue&type=style&index=0&id=35984911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35984911",
  null
  
)

export default component.exports